import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/attribution',
      name: 'Attribution',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Attribution" */ './views/Attribution.vue')
    },
    {
      path: '/recommendation',
      name: 'Recommendation',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Recommendation" */ './views/Recommendation.vue')
    },
    {
      path: '/gains',
      name: 'Gains',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Gains" */ './views/Gains.vue')
    },
    {
      path: '/',
      redirect: '/attribution'
    }
  ]
})
